// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3Fhrk","container":"Footer_container__S1nId","footerText":"Footer_footerText__3Pn68","footerButtons":"Footer_footerButtons__37xWG"};